
export default {
  emits: ['submit'],
  data() {
    return {
      data: undefined,
      first_name: undefined,
      first_name_valid: false,
      last_name: undefined,
      last_name_valid: false,
      title: undefined,
      bio: undefined,
      offering: undefined,
      is_admin: false,
      is_superuser: false,
      is_beta: false,
      is_tenant_manager: false
    }
  },
  computed: {
    can_submit() {
      return (this.first_name != this.data.first_name ||
             this.last_name != this.data.last_name ||
             this.title != this.data.title ||
             this.bio != this.data.bio ||
             this.offering != this.data.offering ||
             this.is_superuser != this.data.is_superuser ||
             this.is_beta != this.data.is_beta ||
             this.is_tenant_manager != this.data.is_tenant_manager) &&
             this.first_name_valid && this.last_name_valid
    }
  },
  methods: {
    open(data){
      this.data = data

      this.first_name = data.first_name
      this.first_name_valid = true

      this.last_name = data.last_name
      this.last_name_valid = true

      this.title = data.title
      this.bio = data.bio
      this.offering = data.offering

      this.is_admin = data.is_admin
      this.is_superuser = data.is_superuser
      this.is_beta = data.is_beta
      this.is_tenant_manager = data.is_tenant_manager

      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.i_fname.focus())
    },
    close() {
      this.$refs.modal.close()
    },
    submit() {
      this.close()
      this.$emit('submit', this.data.id, {
        first_name: this.first_name,
        last_name: this.last_name,
        title: this.title,
        bio: this.bio,
        offering: this.offering,
        is_superuser: this.is_superuser,
        is_beta: this.is_beta,
        is_tenant_manager: this.is_tenant_manager,
      })
    }
  }
}
